import { User } from '@app/models/user';
import { SiteProvisionStatus } from '@app/common/site-provision-status';

export class Project {
  public PdpProjectId: number;
  public ParentPdpProjectId: number;
  public ProjectId: string;
  public OriginProjectId: string;
  public Guid: string;
  public Name: string;
  public Description: string;
  public InfoClass: number;
  public CostCenter: string;
  public Customer: string;
  public StartDate: Date;
  public EndDate: Date;
  public O365GroupId: string;
  public SiteUrl: string;
  public AppliedSiteTemplates: string;
  public SiteProvisionStatus: SiteProvisionStatus;
  public ProjectStatus: string;
  public IsActive: boolean;
  public Retention: number;
  public ArchiveDate: Date;
  public PrivateChannelSitesOnClosure: string;
  public Managers: Array<User>;
  public PliniMessageTimestamp: Date;

  constructor(opt?: Partial<Project>) {
    Object.assign(this, opt);
  }

}

export class ProjectQueryResponse {
  public MoreResultsAvailable: boolean;
  public Projects: Array<Project>;
}
